import { MovieOpenOutlineIcon } from './MovieOpenOutlineIcon';

/**
 * author: GreenTurtwig
 * id 17E4DACC-FDBF-4206-9F03-428157B91803
 * name movie-open-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-outline.svg
 * tags
 * - Video / Movie 
 */
export const ClapperboardOpenOutlineIcon = MovieOpenOutlineIcon;
export default ClapperboardOpenOutlineIcon